/**
 * BRE-9097: Brev's one support address. Kept free of imports so server code
 * (the /login error banners) can name it without pulling in the Intercom SDK.
 */
export const SUPPORT_EMAIL = "success@brev.io";

export const SUPPORT_MAILTO = `mailto:${SUPPORT_EMAIL}`;

/** A mailto drafted about one page: the title in the subject, its address in the body. */
export function supportMailtoAbout(title: string, pageUrl: string): string {
  const subject = encodeURIComponent(`About "${title}"`);
  const body = encodeURIComponent(pageUrl);
  return `${SUPPORT_MAILTO}?subject=${subject}${pageUrl ? `&body=${body}` : ""}`;
}
